/*用户信息 企业信息*/

const state = {
  //用户信息
  userInfo: {},
  //用户企业信息
  userCompany: {},
  //路由菜单配置
  routerMenuList: {},
  //导航菜单配置
  userMenuList: [],
  //铃铛消息
  userNews: {},
  //角色类型
  roleType: '',
  //当前账号权限列表
  permissionMap: {},
  //当前用户权限
  pmsIds: 'false',
  //字典数据
  pageDict: {},
  //UseInfo 是否完成
  userInfoInitFlag: false,
  // 邀约过滤
  inviteFilter: 'false',

}

const getters = {
  userInfo: state => {
    return state.userInfo
  },
  userCompany: state => {
    return state.userCompany
  },
  routerMenuList: state => {
    return state.routerMenuList
  },
  userMenuList: state => {
    return state.userMenuList
  },
  userNews: state => {
    return state.userNews
  },
  roleType: state => {
    return state.roleType
  },
  permissionMap: state => {
    return state.permissionMap
  },
  pmsIds: state => {
    return state.pmsIds
  },
  inviteFilter:state =>{
    return state.inviteFilter
  },
  pageDict: state => {
    return state.pageDict
  },
  userInfoInitFlag: state => {
    return state.userInfoInitFlag
  },
  getYxlevel: () => {
    let map = new Map()
    state.pageDict.commonMap.yxLevel.map(item => {
      map.set('key'+item.dicCode,item.dicName)
    })
    return map
  }
}

const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setUserCompany(state, data) {
    document.title = '沃优客-' + data.companyName
    var list = []
    data.menuList.forEach(item =>{
      if (item.type === 'tjzx') {
        if (state.permissionMap.key220) {
          list.push(item)
        }
      }else if (item.type === 'mdrygl') {
        if (state.permissionMap.key179) {
          list.push(item)
        }
      } else {
        list.push(item)
      }
    })
    data.menuList = list
    state.userCompany = data
    state.userMenuList = data.menuList
    data.menuList.map((item) => {
      state.routerMenuList[item.type] = item.selectFlag
    })
  },
  setUserNews(state, data) {
    state.userNews = data
  },
  setRoleType(state, data) {
    state.roleType = data
  },
  setPermissionMap(state, data) {
    state.permissionMap = data
  },
  setPmsId(state, data) {
    state.pmsIds = data
  },
  setInvite(state,data){
    state.inviteFilter = data
  },
  setUserPageDict(state, data) {
    let bgColor = ''
    let styleNode = document.createElement('style')
    for (let item in data.statusMap) {
      bgColor += '.service' + item + ' td{background-color:' + data.statusMap[item].backColor + ';color:' + data.statusMap[item].fontColor + '}'
    }
    styleNode.innerHTML = bgColor
    document.getElementsByTagName('body')[0].appendChild(styleNode)
    state.pageDict = data
  },
  setUserInfoInitFlag(state, data) {
    state.userInfoInitFlag = data
  }
}

const actions = {
//获取所有用户信息
  getUserBaseInfo(context, data) {
    let that = data
    that.$http.get('login/base_info',).then((data) => {
      if (data) {
        if (data.code === 100000) {
          context.commit('setPermissionMap', data.data.permissionMap)
          context.commit('setUserInfo', data.data.staffDetail)
          context.commit('setUserCompany', data.data.company)
          context.commit('setUserNews', data.data.news)
          context.commit('setUserPageDict', data.data.pageDict)
          let msgSet = data.data.staffDetail.msgSet
          localStorage.setItem('msgSet', msgSet)
          if(!state.userInfoInitFlag){
            context.commit('setUserInfoInitFlag',true)
            that.$root.$emit('get_baseInfo_finish')
          }
        } else {
          that.$Message.error(data.msg)
        }
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/model/useInfor.js